import { Fragment, useCallback, useMemo, useState } from 'react';
import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import carService from '~/assets/icons/car_service.svg';
import cross from '~/assets/icons/cross.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import takeAuction from '~/assets/icons/take_auction.svg';
import { CollectionImage, CurrencyIcon } from '~/components/collections';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import {
	setAuctionCreateVisible,
	setAuctionDoneVisible,
	setAuctionItemSelectVisible,
	useLayoutDispatch,
} from '../../redux';
import { MoneyInput } from '../MoneyInput';
import {
	StyledActivePhotoContainer,
	StyledContainer,
	StyledHeadBackSlot,
	StyledHeadContainer,
	StyledHeadCrossSlot,
	StyledInfoContainer,
	StyledInfoTable,
	StyledInfoTableCell,
	StyledInputContainer,
	StyledMainContainer,
	StyledShadow,
} from './AppAuctionCreate.styled';

const AppAuctionCreate = () => {
	const dispatch = useLayoutDispatch();
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [textAreaValue, setTextAreaValue] = useState('');
	const [startPrice, setStartPrice] = useState(0);
	const [stepPrice, setStepPrice] = useState(0);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const buttonActive = useMemo(() => {
		return startPrice > 0 && stepPrice > 0;
	}, [startPrice, stepPrice]);

	const handlePublish = useCallback(() => {
		if (!buttonActive) {
			return;
		}

		dispatch(setAuctionCreateVisible(false));
		dispatch(setAuctionDoneVisible(true));
	}, [buttonActive]);

	return (
		<StyledContainer>
			<StyledShadow />
			<StyledHeadContainer>
				<StyledHeadBackSlot>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height40}
						borderRadius={ButtonBorderRadius.Radius10}
						onClick={() => {
							dispatch(setAuctionCreateVisible(false));
							dispatch(setAuctionItemSelectVisible(true));
						}}
						style={{
							fontSize: 14,
							padding: '0 10px',
							gap: 10,
						}}
					>
						<img src={arrowLeft} />
						<Text>Вернуться назад</Text>
					</Button>
				</StyledHeadBackSlot>
				<Text
					style={{
						fontSize: 14,
						color: 'rgba(255, 255, 255, 0.5)',
						textAlign: 'center',
					}}
				>
					Аукцион на{' '}
					<span style={{ fontWeight: 500, color: '#ffffff' }}>
						Квартира №827
					</span>
				</Text>
				<StyledHeadCrossSlot>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height40}
						borderRadius={ButtonBorderRadius.Radius10}
						square
						onClick={() => dispatch(setAuctionCreateVisible(false))}
					>
						<img width={14} height={14} src={cross} />
					</Button>
				</StyledHeadCrossSlot>
			</StyledHeadContainer>
			<StyledMainContainer>
				<StyledActivePhotoContainer>
					<CollectionImage collection={'vehicles'} size={156} id={'gaz_2410'} />
				</StyledActivePhotoContainer>
				<StyledInfoContainer>
					<SectionHeading
						icon={carService}
						text="Информация о товаре"
						iconSize={14}
						fontSize={14}
						fontWeight={500}
					/>
					<Divider
						$direction="H"
						style={{ marginTop: 20, marginBottom: 20, opacity: 0.1 }}
					/>
					<StyledInfoTable>
						<Text style={{ opacity: 0.5 }}>Тип имущества</Text>
						<Text style={{ fontWeight: 700 }}>Квартира</Text>
						<Text style={{ opacity: 0.5 }}>Гаражные места</Text>
						<Text style={{ fontWeight: 700 }}>
							10 <span style={{ opacity: 0.5, fontWeight: 400 }}>гм.</span>
						</Text>
						<Text style={{ opacity: 0.5 }}>Гос. стоимость</Text>
						<StyledInfoTableCell>
							<Text style={{ fontWeight: 700 }}>200 000 000</Text>
							<CurrencyIcon
								icon={rubleIcon}
								size="sm"
								style={{ opacity: 0.5 }}
							/>
						</StyledInfoTableCell>
						<Text style={{ opacity: 0.5 }}>Налог в день</Text>
						<StyledInfoTableCell>
							<Text style={{ fontWeight: 700 }}>20 000</Text>
							<CurrencyIcon
								icon={rubleIcon}
								size="sm"
								style={{ opacity: 0.5 }}
							/>
							<Text style={{ opacity: 0.5, fontWeight: 400 }}>д.</Text>
						</StyledInfoTableCell>
					</StyledInfoTable>
				</StyledInfoContainer>
				<StyledInputContainer>
					<MoneyInput
						value={startPrice}
						placeholder={'Начальная ставка'}
						onChange={setStartPrice}
						height={50}
					/>
					<MoneyInput
						value={stepPrice}
						placeholder={'Шаг ставки'}
						onChange={setStepPrice}
						height={50}
						icon={takeAuction}
					/>
				</StyledInputContainer>
				<Button
					height={ButtonHeight.Height60}
					color={ButtonColors.Select2}
					style={{
						fontSize: 18,
						display: 'flex',
						alignItems: 'center',
						gap: 10,
						marginTop: 30,
					}}
					disabled={!buttonActive}
					onClick={handlePublish}
				>
					{buttonActive ? (
						<Fragment>
							<img src={plusRound} width={20} height={20} />
							<Text>Создать аукцион</Text>
						</Fragment>
					) : (
						<Text>Введите стоимость товара</Text>
					)}
				</Button>
			</StyledMainContainer>
		</StyledContainer>
	);
};

export { AppAuctionCreate };
